module.exports = __webpack_public_path__ + "img/people01.b3bf5905.png";